import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import type { HttpEvent } from '@angular/common/http';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
    private readonly router = inject(Router);

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    void this.router.navigate(['/unauthorized']);
                }

                return throwError(() => error);
            })
        );
    }
}
